import React, { useState } from "react";
import PageView from "../../../../../components/commonComponents/Viewpage";
import { useCreateWarehouseMutation } from "../../../../../store/api/VendorWarehouseApi";

function WarehouseCreate() {
  const [createWarehouse, { isLoading, isSuccess, isError }] = useCreateWarehouseMutation();

  const [formData, setFormData] = useState({
    name: "",
    address: "",
    city: "",
    state: "",
    postal_code: "",
    country: "",
    contact_number: "",
  });

  // Handle input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createWarehouse(formData).unwrap();
      alert(" Warehouse created successfully!");
      setFormData({
        name: "",
        address: "",
        city: "",
        state: "",
        postal_code: "",
        country: "",
        contact_number: "",
      });
    } catch (error) {
      console.error("Error creating warehouse:", error);
      alert("❌ Failed to create warehouse. Please try again.");
    }
  };

  return (
    <PageView title="Create Warehouse" closeTo="/dashboard">
      <div className="p-6 bg-white rounded-2xl shadow-md w-full h-[500px] mx-auto">
        <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
          <div>
            <label className="block mb-1 text-gray-600">Warehouse Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full border p-2 rounded-md"
              placeholder="Main Warehouse"
            />
          </div>

          <div>
            <label className="block mb-1 text-gray-600">Contact Number</label>
            <input
              type="text"
              name="contact_number"
              value={formData.contact_number}
              onChange={handleChange}
              required
              className="w-full border p-2 rounded-md"
              placeholder="9999999999"
            />
          </div>

          <div className="col-span-2">
            <label className="block mb-1 text-gray-600">Address</label>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleChange}
              required
              className="w-full border p-2 rounded-md"
              placeholder="123 Street, City"
            />
          </div>

          <div>
            <label className="block mb-1 text-gray-600">City</label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              required
              className="w-full border p-2 rounded-md"
              placeholder="Mumbai"
            />
          </div>

          <div>
            <label className="block mb-1 text-gray-600">State</label>
            <input
              type="text"
              name="state"
              value={formData.state}
              onChange={handleChange}
              required
              className="w-full border p-2 rounded-md"
              placeholder="Maharashtra"
            />
          </div>

          <div>
            <label className="block mb-1 text-gray-600">Postal Code</label>
            <input
              type="text"
              name="postal_code"
              value={formData.postal_code}
              onChange={handleChange}
              required
              className="w-full border p-2 rounded-md"
              placeholder="400001"
            />
          </div>

          <div>
            <label className="block mb-1 text-gray-600">Country</label>
            <input
              type="text"
              name="country"
              value={formData.country}
              onChange={handleChange}
              required
              className="w-full border p-2 rounded-md"
              placeholder="India"
            />
          </div>

          <div className="col-span-2 flex justify-end">
            <button
              type="submit"
              disabled={isLoading}
              className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition"
            >
              {isLoading ? "Creating..." : "Create Warehouse"}
            </button>
          </div>
        </form>
      </div>
    </PageView>
  );
}

export default WarehouseCreate;
